import { reset } from 'src/store'
import { reactive } from 'vue'
import { mergeArrays } from 'src/helpers/globals'

const loggedInStates = () => {
  return [
    'selectionLists'
  ]
}

const defaultStates = () => {
  return {
    selectionLists: {}
  }
}

// the default structure of a registered table
export function EMPTY_SELECTION () {
  return { selected: [], unarchived: [], archived: [], results: [], total: 0 }
}

// access to current object if existing, or new empty object
function getState (state, key) {
  if (!state.selectionLists[key]) {
    state.selectionLists[key] = EMPTY_SELECTION()
  }
  return state.selectionLists[key]
}

// state
export default {
  namespaced: true,
  // not sure why reactivity wasn't working, but this preserved it
  state: reactive(defaultStates()),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    select (state, { key, bool, ids }) {
      const newState = getState(state, key)
      newState.selected = bool ? mergeArrays(newState.selected, ids) : newState.selected.filter(id => !ids.includes(id))
    },
    register (state, { key, ids }) {
      const newState = getState(state, key)
      newState.archived = mergeArrays(newState.archived, ids.archived)
      newState.unarchived = mergeArrays(newState.unarchived, ids.unarchived)
    },
    results (state, { key, ids }) {
      const newState = getState(state, key)
      newState.results = ids
    },
    total (state, { key, total }) {
      const newState = getState(state, key)
      newState.total = total
    },
    update (state, { key, ids }) {
      const newState = getState(state, key)
      newState.archived = ids.archived
      newState.unarchived = ids.unarchived
    },
    deregister (state, key) {
      delete state.selectionLists[key]
    },
    clear (state, key) {
      state.selectionLists[key] = EMPTY_SELECTION()
    }
  },
  actions: {
    select ({ commit }, payload) {
      commit('select', payload)
    },
    reset ({ commit }) {
      commit('reset')
    },
    register ({ commit }, payload) {
      commit('register', payload)
    },
    results ({ commit }, payload) {
      commit('results', payload)
    },
    total ({ commit }, payload) {
      commit('total', payload)
    },
    update ({ commit }, payload) {
      commit('update', payload)
    },
    deregister ({ commit }, key) {
      commit('deregister', key)
    },
    clear ({ commit }, key) {
      commit('clear', key)
    }
  },
  getters: {
    getState: state => key => state.selectionLists[key] || EMPTY_SELECTION()
  }
}
